import { Paper, Typography, Container } from '@mui/material';
import '../../scss/components/mobile-payments.scss';
import { useSelector } from 'react-redux';
import { RootState } from '../../shared/state/root-reducer';
import { useParams, useNavigate } from 'react-router-dom';
import { Button as MUIButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const MobileNoPaymentProgramsView = () => {
  const { patientId, patientEncounterId } = useParams<{ patientId: string; patientEncounterId: string }>();
  const navigate = useNavigate();
  
  const supportEmail = useSelector((state: RootState) =>
    state.guestContext?.clientFacilityDetails?.client?.supportEmail
  );

  const handleBack = () => {
    if (patientId && patientEncounterId) {
      navigate(`/mobile/patient/${patientId}/ioc/${patientEncounterId}/program/optimal`);
    }
  };

  return (
    <Paper className="payment-wrapper">
      <Container>
        <MUIButton variant="text" onClick={handleBack} sx={{ mb: 2 }}>
          <ArrowBackIosIcon /> Back
        </MUIButton>
        <Typography variant="h3" className="pt-2" align="center" color="primary">
          Mobile Program
        </Typography>
        <Typography variant="subtitle2" className="mt-2" align="center">
          No alternative payment programs are currently available via mobile.
          <br />
          <br />
          For further help please contact {supportEmail || 'support@provider.com'}
        </Typography>
      </Container>
    </Paper>
  );
};

export default MobileNoPaymentProgramsView;

